<template>
  <div class="report-career" dir="rtl">
    <div style="margin-top: 200px;" v-if="pathLogo == m "></div>

    <div class="mlogo t-alignlogo">
      <img  class="wlogo" :src="pathLogo" />
     </div>
    <header>
      <div class="md-layout md-size-100">


        <div class="md-layout-item md-size-100 mt-25">

          <h3 class="text-center">{{ allData.fullName }}</h3>
          <h3 class="text-center">{{ allData.shortName }}</h3>
          <h3 class="text-center">
            بطاقة المرتب للموظفين الشهريين مصنفين وغير مصنفين
          </h3>
          <h3 class="text-center" style="margin-left: 50px ; margin-bottom: 100px;
    ">
            بتاريخ : {{ convert(new Date()) }}
          </h3>
        </div>



        <!-- <div class="md-layout-item md-size-25">
                  <h3 class="text-left">المصلحة : <span style="margin-right: 10px;">{{allData.employeeName}}</span> </h3>
                  <h4 class="text-left"></h4>
                </div> -->

        <div class="md-layout-item md-size-25">
          <h3 class="text-left">الإسم : <span style="margin-right: 10px;">{{ allData.employeeName }}</span> </h3>
          <h4 class="text-left"></h4>
        </div>

        <div class="md-layout-item md-size-25">
          <h3 class="text-left">المصرف : <span style="margin-right: 10px;">{{ allData.bankBranchName }}</span> </h3>
          <h4 class="text-left"></h4>
        </div>

        <div class="md-layout-item md-size-10">
          <h3 class="text-left">الدرجة : <span style="margin-right: 10px;">{{ allData.degree }}</span></h3>
          <h4 class="text-left"></h4>
        </div>

        <div class="md-layout-item md-size-15">
          <h3 class="text-left">العلاوة : <span style="margin-right: 10px;">{{ allData.bonuse }}</span></h3>
          <h4 class="text-left"></h4>
        </div>

        <div class="md-layout-item md-size-25">
          <h3 class="text-left">مقر الوظيفة : <span style="margin-right: 10px;">{{ allData.workPlace }}</span> </h3>
          <h4 class="text-left"></h4>
        </div>

        <div class="md-layout-item md-size-25">
          <h3 class="text-left"> الوظيفة : <span style="margin-right: 10px;">{{ allData.job }}</span></h3>
          <h4 class="text-left"></h4>
        </div>

        <div class="md-layout-item md-size-20">
          <h3 class="text-left"> رقم الحساب : <span style="margin-right: 10px;">{{ allData.accountNumber }}</span> </h3>
          <h4 class="text-left"></h4>
        </div>

        <div class="md-layout-item md-size-20">
          <h3 class="text-left"> رقم الحساب الآلي : <span style="margin-right: 10px;">{{ allData.financialNumber }}</span>
          </h3>
          <h4 class="text-left"></h4>
        </div>

        <div class="md-layout-item md-size-15" style="margin-bottom: 50px;">
          <h3 class="text-left"> شهر الزيادة : <span style="margin-right: 10px;">{{ convert(allData.bonusDueDate
            )
          }}</span></h3>
          <h4 class="text-left"></h4>
        </div>

      </div>



      <!-- <div class="md-layout-item md-size-100 mt-25">
        <h2 style="margin-bottom: 15px" class="text-center">{{ fullName }}</h2>
        <h3 style="margin-top: 0px; font-weight: bold" class="text-center">
          {{ shortName }}
        </h3>

        <h2 style="margin-bottom: 15px" class="text-center">شركة البرمجيات الدقيقة</h2>
        <h3 style="margin-top: 0px; font-weight: bold" class="text-right">
        للحلول البرمجية وخدمات تقنية المعلومات
        </h3>
        <h3 style="font-weight: bold" class="text-center">
        
        </h3>
        <div class="text-center" style="direction: ltr; display: flex"></div>
      </div> -->
    </header>

    <div class="container">
      <div class="c1-t c_all">الشهر</div>
      <div class="c2-t c_all">الأساسي</div>
      <div class="c3-t c_all">الإجمالي</div>
      <div class="c4-t c_all">الإجمالي</div>
      <div class="c5-t c_all">الخصميات</div>
      <div class="c6-t c_all">الخصميات</div>
      <div class="c7-t c_all">صافي المرتب</div>
      <div class="c8-t c_all" style="border-left: none; ">الملاحظات</div>
      <div class="c1-b "></div>
      <div class="c2-b"></div>
      <div class="c3-b">
        <div class="c3-b-1 c_all">ع.اللجان</div>
        <div class="c3-b-2 c_all">ع. المكافآت</div>
        <div class="c3-b-3 c_all">ع.العمل الإضافي</div>
        <div v-for="(item, j ) in allowances" :key="j">
          <div style="border-left: none;" class="c3-b-4 c_all">{{ item.key }}</div>
        </div>
        <!-- <div class="c3-b-4 c_all">ع.سكن</div>
    <div class="c3-b-5 c_all" style="border-left: none; ">د.سلع</div> -->
      </div>
      <div class="c4-b"></div>
      <div class="c5-b">
        <div class="c5-b-1 c_all">الضمان</div>
        <div class="c5-b-2 c_all">التضامن</div>
        <div class="c5-b-3 c_all">الدخل</div>
        <div class="c5-b-4 c_all">الجهاد</div>
        <div class="c5-b-5 c_all">الدمغة</div>
        <div class="c5-b-6 c_all">الدينار</div>
        <div class="c5-b-7 c_all" style="border-left: none; ">خ.غياب</div>
      </div>
      <div class="c6-b"></div>
      <div class="c7-b"></div>
      <div class="c8-b" style="border-left: none; ">
        <div class="c8-b-1 c_all">فروقات</div>
        <div class="c8-b-2 c_all " style="border-left: none; ">خصميات اخرى</div>
      </div>
    </div>

    <div v-for="(item, i ) in tableData" :key="i" class="container-body">
      <div class="c1-b b_all">{{ convert(item.date) }}</div>
      <div class="c2-b b_all">{{ item.basicSalary }}</div>

      <div class="c3-b b_all">{{ item.committeesAllownace }}</div>
      <div class="c4-b b_all">{{ item.rewards }}</div>
      <div class="c5-b b_all">{{ item.overTime }}</div>
      <div v-for="(item, j ) in allowances" :key="j">
        <div style="border-left: none;" class="c6-b b_all">{{ item.value }}</div>
      </div>
      <!-- <div class="c7-b b_all">{{item.warrantyTax}}</div> -->

      <div class="c8-b b_all"> {{ item.totalSalary }}</div>

      <div class="c9-b b_all"> {{ item.warrantyTax }}</div>
      <div class="c10-b b_all">{{ item.solidarityTax }}</div>
      <div class="c11-b b_all">{{ income }}</div>
      <div class="c12-b b_all">{{ item.jihadTax }}</div>
      <div class="c13-b b_all">{{ item.stampTax }}</div>
      <div class="c14-b b_all">{{ dinar }}</div>
      <div class="c15-b b_all">{{ item.absanceDiscount }}</div>

      <div class="c16-b b_all">{{ item.totalDiscount }}</div>

      <div class="c17-b b_all">{{ item.netSalary }}</div>

      <div class="c18-b b_all">{{ item.differences }}</div>
      <div class="c19-b b_all">{{ item.otherDiscounts }}</div>
    </div>

<div class="md-layout mt-25 text-center last-footer">
    <div class="md-layout-item md-size-30">
      <p style="font-weight: bold">توقيع وإعتماد رئيس القسم المالي</p>

    </div>

    <div class="md-layout-item md-size-30">
        <p style="font-weight: bold">توقيع وإعتماد مدير الشؤون الإدارية والمالية</p>
    </div>

     <div class="md-layout-item md-size-30">
        <p style="font-weight: bold">توقيع وإعتماد المراجعة الداخلية</p>
    </div>

  </div>

  
  </div>
</template>

<script>
 import env from "../../../env";

export default {

  props: ["allData", "tableData", "allowances","pathLogo"],

  data() {
    return {
      income: 0,
      dinar: 1,
      m:env.mTop(),


    }
  },

  methods: {
    convert(event) {
      try {
        let d = new Date(event);
        if (isNaN(d.getFullYear()) === true) {
          return "-";
        }
        return (
          d.getDate() + "-" + (d.getMonth() + 1) + "-" + d.getFullYear()

          // +
          // " , "
          // +
          // d.getHours() +
          // ":" +
          // d.getMinutes()
        );
      } catch (error) { }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/SalaryCard";
</style>
